/* ==========================================================================
   MILFSHAKES · CARRUSEL DE LAS RECOMENDACIONES DEL CARRITO VACÍO
   --------------------------------------------------------------------------
   Lo usa snippets/cart-empty-recommendations.liquid (<mfs-recs-carousel>).

   Por qué no se usa el <scroll-carousel> del tema: ese componente mueve la
   fila por su cuenta (al cambiar de tamaño vuelve a "seleccionar" la tarjeta
   que cree activa, y en el editor responde a eventos de bloque), y junto con
   el scroll-snap obligatorio hacía que la fila se desplazara sola al
   repintarse la sección. Este componente NUNCA mueve la fila por sí mismo:
   empieza siempre en el primer producto y solo se desplaza cuando alguien
   pulsa una flecha o desliza con el dedo.

   Se carga desde snippets/mfs-mejoras.liquid en todas las páginas, porque el
   cajón se vuelve a pintar con JS al cambiar el carrito y los <script> que
   llegan así no se ejecutan.
   ========================================================================== */

(function () {
  if (window.customElements.get('mfs-recs-carousel')) return;

  class MfsRecsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mfs-track]');
      this.prevButton = this.querySelector('[data-mfs-prev]');
      this.nextButton = this.querySelector('[data-mfs-next]');
      if (!this.track) return;

      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      // Siempre desde el primer producto, también tras un repintado del editor
      this.track.scrollLeft = 0;

      this.prevButton?.addEventListener('click', () => this.go(-1), { signal });
      this.nextButton?.addEventListener('click', () => this.go(1), { signal });
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true, signal });

      // Solo actualiza las flechas; nunca desplaza la fila. Se vigilan también las
      // tarjetas: si cambia su ancho (p. ej. al terminar de cargar el CSS) la fila
      // pasa a ser desplazable sin que cambie el tamaño del contenedor.
      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.track);
      Array.from(this.track.children).forEach((card) => this.resizeObserver.observe(card));

      this.updateButtons();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    // Distancia entre el inicio de una tarjeta y el de la siguiente (ancho + hueco)
    get step() {
      const cards = this.track.children;
      return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : this.track.clientWidth;
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    // Avanza o retrocede una tarjeta, dejándola alineada al borde izquierdo
    go(direction) {
      const step = this.step;
      if (step <= 0) return;

      const index = Math.round(this.track.scrollLeft / step) + direction;
      const left = Math.min(Math.max(index * step, 0), this.maxScroll);
      this.track.scrollTo({ left, behavior: 'smooth' });
    }

    updateButtons() {
      // Margen de unos píxeles: el redondeo de anchos en % deja a veces 2-3 px
      // "desplazables" cuando en realidad caben todas las tarjetas
      const tolerance = 4;
      const max = this.maxScroll;
      const left = this.track.scrollLeft;

      this.classList.toggle('is-scrollable', max > tolerance);
      if (this.prevButton) this.prevButton.disabled = left <= tolerance;
      if (this.nextButton) this.nextButton.disabled = left >= max - tolerance;

      // Para centrar las flechas sobre la imagen y no sobre imagen + título + precio
      const media = this.track.querySelector('.cs-card__media');
      if (media) this.style.setProperty('--mfs-recs-media-height', `${media.offsetHeight}px`);
    }
  }

  window.customElements.define('mfs-recs-carousel', MfsRecsCarousel);
})();
